/* global axios */
import ApiClient from './ApiClient';

class OrderIssuesAPI extends ApiClient {
  constructor() {
    super('order_issues', { accountScoped: true });
  }

  getActive(hiddenFilter = null) {
    const params = new URLSearchParams({ archived: 'false' });
    if (hiddenFilter !== null) {
      params.append('hidden', hiddenFilter);
    }
    return axios.get(`${this.url}?${params.toString()}`);
  }

  getArchived(hiddenFilter = null) {
    const params = new URLSearchParams({ archived: 'true' });
    if (hiddenFilter !== null) {
      params.append('hidden', hiddenFilter);
    }
    return axios.get(`${this.url}?${params.toString()}`);
  }

  getByConversation(conversationId) {
    return axios.get(`${this.url}/by_conversation`, {
      params: { conversation_id: conversationId },
    });
  }

  getByContact(contactId) {
    return axios.get(`${this.url}/by_contact`, {
      params: { contact_id: contactId },
    });
  }

  create(orderIssueObj) {
    return axios.post(`${this.url}`, orderIssueObj);
  }

  update(id, orderIssueObj) {
    return axios.patch(`${this.url}/${id}`, orderIssueObj);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  markAsDone(id) {
    return axios.patch(`${this.url}/${id}`, {
      order_issue: { done: true },
    });
  }

  unarchive(id) {
    return axios.patch(`${this.url}/${id}`, {
      order_issue: { done: false },
    });
  }

  toggleHidden(id, hidden) {
    return axios.patch(`${this.url}/${id}`, {
      order_issue: { hidden },
    });
  }

  // Tag Settings
  getTagSettings() {
    return axios.get(`${this.url.replace('order_issues', 'order_issue_tag_settings')}`);
  }

  bulkUpdateTagSettings(settings) {
    return axios.post(`${this.url.replace('order_issues', 'order_issue_tag_settings')}/bulk_update`, {
      settings,
    });
  }

  // Support Metric Categories (for EcomOS integration)
  getMetricCategories() {
    return axios.get(`${this.url.replace('order_issues', 'support_metric_categories')}`);
  }

  getAvailableTags() {
    return axios.get(`${this.url.replace('order_issues', 'support_metric_categories')}/available_tags`);
  }

  createMetricCategory(category) {
    return axios.post(`${this.url.replace('order_issues', 'support_metric_categories')}`, {
      support_metric_category: category,
    });
  }

  updateMetricCategory(id, category) {
    return axios.patch(`${this.url.replace('order_issues', 'support_metric_categories')}/${id}`, {
      support_metric_category: category,
    });
  }

  deleteMetricCategory(id) {
    return axios.delete(`${this.url.replace('order_issues', 'support_metric_categories')}/${id}`);
  }

  seedDefaultCategories() {
    return axios.post(`${this.url.replace('order_issues', 'support_metric_categories')}/seed_defaults`);
  }

  resetCategoriesToDefaults() {
    return axios.post(`${this.url.replace('order_issues', 'support_metric_categories')}/reset_to_defaults`);
  }
}

export default new OrderIssuesAPI();
